var map = {
	"./bootstrap-logo.webp": 5650,
	"./css-logo.webp": 1842,
	"./html-logo.webp": 2347,
	"./javascript-logo.webp": 1307,
	"./react-logo.webp": 5271,
	"./tailwindcss-logo.webp": 3437,
	"./vue-logo.webp": 4305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7623;